const de = {
  meta: {
    title: "Rocknitive - Individualsoftware, AI & IoT aus Deutschland",
  },
  header: {
    nav: [
      { name: "Leistungen", id: "leistungen" },
      { name: "AI", id: "ai-first" },
      { name: "IoT", id: "iot-triprock" },
      { name: "So arbeiten wir", id: "prozess" },
      { name: "Projekte", id: "referenzen" },
    ],
    cta: "Erstgespräch buchen",
  },
  hero: {
    headlinePlain: "Engineering for",
    headlineAccent: "Transparency",
    sub: "Individualsoftware, AI und IoT für Mittelstand und Konzerne - von einem Partner, bei dem Sie jederzeit wissen, woran Sie sind.",
    tagline: "Volle Transparenz vom ersten Gespräch bis zum laufenden Betrieb.",
    ctaPrimary: "Kostenloses Erstgespräch buchen",
    ctaSecondary: "So arbeiten wir →",
    trust: [
      "2.000+ IoT-Geräte im Dauereinsatz",
      "Softwareentwicklung aus Deutschland",
      "Direkter Draht zum Entwicklerteam",
      "Betrieb bei uns oder on-premise",
    ],
  },
  services: {
    overline: "Leistungen",
    headline: "Ein Partner. Das volle Software-Spektrum.",
    intro:
      "Ob Sie eine Idee validieren, ein Altsystem ablösen oder einen kompletten Produktlaunch stemmen - wir übernehmen Verantwortung für das Ganze, nicht nur für den Code.",
    cards: [
      {
        title: "Individualsoftware",
        text: "Maßgeschneiderte Anwendungen für Ihre Geschäftsprozesse. Von der Anforderungsanalyse bis zum Rollout - Software, die genau das tut, was Ihr Unternehmen braucht.",
      },
      {
        title: "Web-Applikationen",
        text: "Moderne, schnelle Web-Apps für interne Tools, Kundenportale und SaaS-Produkte. Wartbar gebaut, damit sie auch in fünf Jahren noch weiterentwickelt werden können.",
      },
      {
        title: "Mobile Apps",
        text: "Native und Cross-Platform-Apps für iOS und Android. Vom Prototyp bis zum Store-Release - inklusive Backend, Updates und Betrieb.",
      },
      {
        title: "Cloud & Backend",
        text: "Skalierbare Backend-Systeme und Cloud-Architekturen. Wir bauen die Infrastruktur, auf der Ihre Anwendungen zuverlässig laufen - bei einem Cloud-Anbieter Ihrer Wahl oder on-premise.",
      },
      {
        title: "Systemintegration",
        text: "Wir verbinden, was zusammengehört: ERP, CRM, Maschinendaten, Drittanbieter-APIs. Damit Ihre Systeme miteinander sprechen, statt aneinander vorbei.",
      },
      {
        title: "AI & IoT",
        text: "Unsere beiden Schwerpunkte, im Detail weiter unten: AI-Integration in Produkte und Prozesse sowie komplette IoT-Systeme aus eigener Entwicklung.",
      },
    ],
    linkAi: "Zu AI ↓",
    linkIot: "Zu IoT ↓",
    closing:
      "Egal, in welche Kategorie Ihr Vorhaben fällt: Erzählen Sie uns einfach, was Sie erreichen wollen.",
    cta: "Erstgespräch buchen",
  },
  aiFirst: {
    overline: "AI-First",
    headlinePlain: "AI, die im Betrieb funktioniert -",
    headlineAccent: "nicht nur in der Demo.",
    intro:
      "Jede Agentur schreibt sich gerade „AI“ auf die Website. Wir setzen AI seit der ersten Stunde täglich ein - in Kundenprojekten, in unseren eigenen Produkten und in unserem eigenen Entwicklungsprozess. Der Unterschied: Wir wissen aus der Praxis, was zuverlässig funktioniert, was Geld spart und wo AI (noch) die falsche Antwort ist.",
    columns: [
      {
        title: "AI in Ihren Produkten",
        text: "Wir integrieren Sprachmodelle, Dokumentenanalyse, Klassifikation und Assistenz-Funktionen in Ihre bestehende Software - mit sauberem Umgang mit Ihren Daten, nachvollziehbaren Ergebnissen und Kosten, die kalkulierbar bleiben.",
      },
      {
        title: "AI in Ihren Prozessen",
        text: "Angebotserstellung, Dokumentenverarbeitung, Support, Qualitätskontrolle: Wir identifizieren die Prozesse in Ihrem Unternehmen, bei denen AI messbar Zeit spart - und automatisieren sie so, dass Ihre Mitarbeiter die Kontrolle behalten.",
      },
      {
        title: "AI in unserer Entwicklung",
        text: "Wir entwickeln selbst AI-gestützt - und geben den Geschwindigkeitsvorteil an Sie weiter. Schnellere Iterationen, gründlichere Tests, mehr Zeit für das, was zählt: Ihr Problem wirklich zu verstehen.",
      },
    ],
    antiHypePlain: "Und wenn AI für Ihren Fall nicht das richtige Werkzeug ist?",
    antiHypeAccent: "Dann sagen wir Ihnen das. Vor dem Projekt, nicht danach.",
    ctaLine:
      "Sie überlegen, was AI für Ihr Unternehmen konkret bringen kann? Genau dafür ist unser kostenloses Erstgespräch da.",
    ctaLink: "Konkreten AI-Anwendungsfall besprechen →",
  },
  understanding: {
    overline: "Die Anforderung hinter der Anforderung",
    headline: "Das eigentliche Problem: Es wird gebaut, bevor verstanden wurde.",
    p1: "Hinter fast jeder Anforderung steckt eine zweite, wichtigere: das Ziel dahinter. „Ein Dashboard“ kann vieles bedeuten - schneller entscheiden, Probleme früher erkennen oder Berichte automatisieren. Je nachdem, was zutrifft, sieht die richtige Lösung ganz anders aus.",
    p2: "Die meisten Dienstleister bauen einfach, was bestellt wurde. Wir klären zuerst das Ziel - und bauen dann oft etwas Besseres als das, was ursprünglich im Lastenheft stand.",
    saidLabel: "Sie sagen",
    meaningsLabel: "Das kann bedeuten",
    clarify: "Genau das klären wir, bevor wir bauen.",
    exampleAria: "Beispiel",
    examples: [
      {
        said: "„Wir brauchen ein Dashboard.“",
        meanings: [
          "Schneller entscheiden?",
          "Probleme früher erkennen?",
          "Berichte automatisieren?",
        ],
      },
      {
        said: "„Wir brauchen eine App.“",
        meanings: [
          "Kunden enger binden?",
          "Prozesse mobil machen?",
          "Eine neue Zielgruppe erreichen?",
        ],
      },
      {
        said: "„Wir wollen AI einführen.“",
        meanings: [
          "Kosten senken?",
          "Schneller liefern?",
          "Wissen im Unternehmen verfügbar machen?",
        ],
      },
    ],
    principles: [
      {
        title: "Erst verstehen, dann entwickeln.",
        text: "Wir stellen die unbequemen Fragen am Anfang - nicht die teuren am Ende.",
      },
      {
        title: "Klartext statt Buzzwords.",
        text: "Sie bekommen von uns eine ehrliche Einschätzung, was technisch sinnvoll ist. Auch wenn die Antwort lautet: „Das brauchen Sie nicht.“",
      },
      {
        title: "Jede Herausforderung.",
        text: "Wir sind bewusst breit aufgestellt - weil echte Probleme sich selten an Technologie-Grenzen halten.",
      },
    ],
  },
  process: {
    overline: "So arbeiten wir",
    headline: "Volle Transparenz: So läuft ein Projekt mit uns.",
    intro:
      "Die meisten Softwareprojekte scheitern nicht am Code, sondern an Missverständnissen. Deshalb ist unser Prozess darauf gebaut, dass Sie in jeder Phase wissen, wo Ihr Projekt steht - und jederzeit eingreifen können.",
    steps: [
      {
        title: "Erstgespräch",
        badge: "kostenlos & unverbindlich",
        text: "30 Minuten, in denen wir zuhören. Sie schildern Ihr Vorhaben, wir stellen die Fragen, die andere vergessen. Am Ende wissen Sie, ob und wie wir Ihnen helfen können - auch wenn die ehrliche Antwort „gar nicht“ lautet.",
      },
      {
        title: "Anforderungen verstehen",
        text: "Unsere Spezialität: herausfinden, was Sie eigentlich brauchen - nicht nur, was im Lastenheft steht. Wir hinterfragen, skizzieren und schärfen gemeinsam mit Ihnen, bis das Ziel klar ist. Erst dann sprechen wir über Umfang und Budget.",
      },
      {
        title: "Transparentes Angebot",
        text: "Sie bekommen ein Angebot, das Sie verstehen: was gebaut wird, in welchen Etappen, was es kostet - alle Positionen klar aufgeschlüsselt, planbar bis zum Schluss. Und wenn die einfachere Lösung Ihr Ziel besser erreicht, schlagen wir sie vor - auch wenn das Projekt dadurch kleiner wird.",
      },
      {
        title: "Entwicklung in kurzen Zyklen",
        text: "Wir liefern in kurzen, sichtbaren Etappen. Sie sehen regelmäßig funktionierende Zwischenstände - nicht nur Statusberichte. Änderungen? Gehören dazu. Wir planen so, dass Kurskorrekturen möglich bleiben.",
      },
      {
        title: "Übergabe & Betrieb",
        text: "Nach dem Launch bleiben wir an Ihrer Seite: Betrieb, Monitoring, Weiterentwicklung - bei uns gehostet oder in Ihrer Infrastruktur. Ihr Code, Ihre Daten, Ihre Entscheidung.",
      },
    ],
    closing: "Der erste Schritt kostet Sie lediglich 30 Minuten.",
    cta: "Erstgespräch buchen",
  },
  iot: {
    overline: "IoT & TripRock",
    headlinePlain: "IoT, das im Feld läuft:",
    headlineAccent: "über 2.000 Geräte im produktiven Einsatz.",
    intro:
      "Unsere Software beweist ihre Produktionsreife jeden Tag im Dauerbetrieb. Unter der Marke TripRock entwickeln wir gemeinsam mit unseren Partnern eigene IoT-Sensoren und IoT-Systeme - Hardware und Software aus einer Hand, Made in Germany. Das ist ein Kompetenznachweis, der stärker wirkt als jede Referenzfolie.",
    statLabels: [
      "Geräte im produktiven Einsatz",
      "Jahre Messtechnik-Erfahrung",
      "Monate Batterielaufzeit",
    ],
    blocks: [
      {
        title: "Eigene Sensorik & Devices",
        text: "Von der Platine bis zur App: Wir entwickeln IoT-Geräte, die im Feld durchhalten - mit bis zu 24 Monaten Batterielaufzeit und robuster Funkanbindung.",
      },
      {
        title: "DataHub, unser IoT-Backend",
        text: "Unser selbst entwickeltes Backend übernimmt das komplette Gerätemanagement: OTA-Updates, Datenweiterleitung per HTTP und MQTT, Alerts, AI-gestütztes Monitoring und Dashboards - alles an einem Ort.",
      },
      {
        title: "Ihr Hosting, Ihre Regeln",
        text: "DataHub läuft bei uns als Managed Service - oder komplett on-premise in Ihrer Infrastruktur. Ihre Gerätedaten verlassen Ihr Haus nur, wenn Sie das wollen. Ihre Daten, Ihre Entscheidung.",
      },
      {
        title: "Auch für Ihr IoT-Projekt",
        text: "Sie haben eigene Geräte, Maschinen oder ein IoT-Vorhaben? Wir bringen Erfahrung aus eigener Produktentwicklung mit - von der Hardware-Auswahl über die Konnektivität bis zur Auswertung.",
      },
    ],
    showcaseLabel: "Unsere Produkte unter TripRock",
    products: [
      "Umwelt- & Klimasensor",
      "Fracht-Monitoring",
      "Wasser-Detektor",
      "Positions-Monitoring",
    ],
    showcaseLink: "Alle Produkte auf triprock.de →",
    marqueeHeading: "Modulare Plattform - eine Auswahl unserer Sensorik",
    sensors: [
      "NB-IoT / GSM",
      "GPS",
      "Temperatur",
      "Feuchtigkeit",
      "Feinstaub",
      "Beschleunigung",
      "Vibration",
      "Batterie",
      "Position",
      "Geofencing",
      "Meshnet",
      "Wasser",
      "Stromfluss",
      "Zugriffsschutz",
    ],
    footerLine: "Mehr zur IoT-Marke und den Produkten:",
  },
  references: {
    overline: "Projekte",
    headline: "Vertrauen entsteht durch Ergebnisse.",
    intro:
      "Von der Prozess-Automatisierung im Mittelstand bis zum IoT-Rollout mit tausenden Geräten - ein Einblick in die Art von Projekten, die wir umsetzen.",
    cards: [
      {
        tags: ["Individualsoftware", "Systemintegration"],
        title: "Prozesse digitalisieren, Systeme verbinden",
        text: "Maßgeschneiderte Fachanwendungen, die gewachsene Abläufe abbilden und Bestandssysteme wie ERP und CRM sauber anbinden - damit Daten fließen statt in Silos zu liegen.",
      },
      {
        tags: ["AI", "Automatisierung"],
        title: "AI in bestehende Software und Abläufe bringen",
        text: "Dokumentenverarbeitung, Assistenz-Funktionen und intelligente Automatisierung - integriert in vorhandene Systeme, produktionsreif statt Proof-of-Concept.",
      },
      {
        tags: ["IoT", "DataHub"],
        title: "IoT-Rollouts vom Sensor bis zum Dashboard",
        text: "Eigene Sensorik, Gerätemanagement und Datenauswertung über unser Backend DataHub - über 2.000 Geräte laufen heute produktiv damit.",
      },
    ],
    facts: [
      "2.000+ IoT-Geräte im produktiven Einsatz",
      "Eigene Produkte unter der Marke TripRock",
      "Softwareentwicklung aus Deutschland",
    ],
    closing:
      "Sie möchten wissen, ob wir ein Projekt wie Ihres schon umgesetzt haben? Fragen Sie uns direkt - im Erstgespräch zeigen wir Ihnen passende Beispiele.",
    ctaLink: "Erstgespräch buchen →",
  },
  values: {
    headline: "Woran Sie merken, dass Sie mit uns richtig liegen.",
    cards: [
      {
        title: "Wir verstehen, was Sie eigentlich brauchen",
        text: "Hinter jeder Anforderung steckt ein Ziel. Wir fragen so lange nach, bis wir es kennen - und schlagen auch mal die einfachere Lösung vor, wenn sie das Ziel besser erreicht. Auch wenn sie für uns weniger Umsatz bedeutet.",
      },
      {
        title: "Wir sagen Nein, wenn Nein die richtige Antwort ist",
        text: "Wenn ein Vorhaben aus unserer Sicht nicht funktioniert oder sich nicht rechnet, sagen wir es Ihnen im Erstgespräch - nicht in Monat sechs.",
      },
      {
        title: "Sie sprechen mit denen, die bauen",
        text: "Sie haben direkten Draht zu den Entwicklern, die Ihr Projekt umsetzen - Entscheidungen fallen schnell und ohne Reibungsverlust.",
      },
      {
        title: "Flexibel im Weg, verbindlich im Ziel",
        text: "Anforderungen ändern sich - das ist normal. Was bei uns konstant bleibt: Erreichbarkeit, Zusagen und die Qualität dessen, was wir liefern.",
      },
    ],
    footnote:
      "Rocknitive GmbH - Softwareentwicklung aus Deutschland. Gemeinsam mit unseren Partnern decken wir Software und Hardware aus einer Hand ab.",
  },
  contact: {
    overline: "Kontakt",
    headlinePlain: "Lernen wir uns kennen:",
    headlineAccent: "30 Minuten, kostenlos, unverbindlich.",
    intro:
      "Ein offenes Gespräch statt Verkaufs-Pitch: Sie erzählen uns von Ihrem Vorhaben, wir stellen die richtigen Fragen und sagen Ihnen ehrlich, was wir davon halten - und wie ein Weg zur Umsetzung aussehen könnte.",
    takeawaysLabel: "Das nehmen Sie aus dem Gespräch mit",
    takeaways: [
      "Eine ehrliche erste Einschätzung Ihres Vorhabens",
      "Eine klare Antwort, ob AI dabei einen echten Mehrwert bringt",
      "Konkrete nächste Schritte - auch wenn Sie sie ohne uns gehen",
    ],
    cardTitle: "Termin direkt online buchen",
    cardText:
      "Wählen Sie einen freien Slot in unserem Kalender - in unter einer Minute gebucht.",
    cardButton: "Termin direkt buchen",
    cardExternal: "Oder direkt bei Calendly öffnen ↗",
    cardGdpr: "Beim Laden des Kalenders werden Daten an Calendly übertragen.",
    calendlyTitle: "Calendly - Termin buchen",
    emailPrefix: "Lieber schreiben?",
    emailSuffix: "- wir melden uns zeitnah zurück.",
    microTrust:
      "Kostenlos & unverbindlich · Direkter Kontakt zum Entwicklerteam · Antwort garantiert",
    microReassurance:
      "Sie sprechen von Anfang an direkt mit jemandem, der Ihre Lösung später mitentwickelt.",
  },
  footer: {
    brand:
      "Rocknitive GmbH - Softwareentwicklung aus Deutschland. Individualsoftware, AI und IoT für Mittelstand und Konzerne.",
    navLabel: "Navigation",
    nav: [
      { name: "Leistungen", id: "leistungen" },
      { name: "AI", id: "ai-first" },
      { name: "IoT & TripRock", id: "iot-triprock" },
      { name: "So arbeiten wir", id: "prozess" },
      { name: "Projekte", id: "referenzen" },
      { name: "Arbeitsweise", id: "arbeitsweise" },
      { name: "Kontakt", id: "kontakt" },
    ],
    projectsLabel: "Projekte",
    triprockLabel: "TripRock - IoT 360°, alles aus einer Hand",
    contactLabel: "Kontakt",
    bookCall: "Erstgespräch buchen →",
    imprint: "Impressum",
    privacy: "Datenschutz",
  },
  imprint: {
    title: "Impressum",
    tmg: "Angaben gemäß § 5 TMG",
    directors: "Vertretungsberechtigte Geschäftsführer:",
    court: "Registergericht:",
    courtValue: "Amtsgericht Lübeck",
    regNumber: "Registernummer:",
    responsible: "Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:",
    back: "Zurück",
  },
  privacy: {
    title: "Datenschutzerklärung",
    note: "",
    back: "Zurück",
  },
};

const en: typeof de = {
  meta: {
    title: "Rocknitive - Custom Software, AI & IoT from Germany",
  },
  header: {
    nav: [
      { name: "Services", id: "leistungen" },
      { name: "AI", id: "ai-first" },
      { name: "IoT", id: "iot-triprock" },
      { name: "How we work", id: "prozess" },
      { name: "Projects", id: "referenzen" },
    ],
    cta: "Book an intro call",
  },
  hero: {
    headlinePlain: "Engineering for",
    headlineAccent: "Transparency",
    sub: "Custom software, AI and IoT for mid-sized companies and enterprises - from a partner where you always know where you stand.",
    tagline: "Full transparency from the first conversation to live operations.",
    ctaPrimary: "Book a free intro call",
    ctaSecondary: "How we work →",
    trust: [
      "2,000+ IoT devices in the field",
      "Software engineering from Germany",
      "Direct line to the developers",
      "Hosted by us or on-premise",
    ],
  },
  services: {
    overline: "Services",
    headline: "One partner. The full software spectrum.",
    intro:
      "Whether you are validating an idea, replacing a legacy system or launching an entire product - we take responsibility for the whole, not just the code.",
    cards: [
      {
        title: "Custom Software",
        text: "Tailor-made applications for your business processes. From requirements analysis to rollout - software that does exactly what your company needs.",
      },
      {
        title: "Web Applications",
        text: "Modern, fast web apps for internal tools, customer portals and SaaS products. Built to stay maintainable, so they can still evolve five years from now.",
      },
      {
        title: "Mobile Apps",
        text: "Native and cross-platform apps for iOS and Android. From prototype to store release - including backend, updates and operations.",
      },
      {
        title: "Cloud & Backend",
        text: "Scalable backend systems and cloud architectures. We build the infrastructure your applications run on reliably - with the cloud provider of your choice or on-premise.",
      },
      {
        title: "System Integration",
        text: "We connect what belongs together: ERP, CRM, machine data, third-party APIs. So your systems talk to each other instead of past each other.",
      },
      {
        title: "AI & IoT",
        text: "Our two focus areas, covered in detail below: AI integration into products and processes, plus complete IoT systems developed in-house.",
      },
    ],
    linkAi: "To AI ↓",
    linkIot: "To IoT ↓",
    closing:
      "Whatever category your project falls into: just tell us what you want to achieve.",
    cta: "Book an intro call",
  },
  aiFirst: {
    overline: "AI-First",
    headlinePlain: "AI that works in production -",
    headlineAccent: "not just in the demo.",
    intro:
      "Every agency is putting “AI” on their website right now. We have used AI every day since day one - in client projects, in our own products and in our own development process. The difference: we know from hands-on experience what works reliably, what saves money and where AI is (still) the wrong answer.",
    columns: [
      {
        title: "AI in your products",
        text: "We integrate language models, document analysis, classification and assistant features into your existing software - with clean data handling, traceable results and costs that stay predictable.",
      },
      {
        title: "AI in your processes",
        text: "Quoting, document processing, support, quality control: we identify the processes in your company where AI saves measurable time - and automate them in a way that keeps your team in control.",
      },
      {
        title: "AI in our development",
        text: "We develop AI-assisted ourselves - and pass the speed advantage on to you. Faster iterations, more thorough testing, more time for what matters: truly understanding your problem.",
      },
    ],
    antiHypePlain: "And if AI is the wrong tool for your case?",
    antiHypeAccent: "We will tell you. Before the project, not after.",
    ctaLine:
      "Wondering what AI can actually do for your company? That is exactly what our free intro call is for.",
    ctaLink: "Discuss a concrete AI use case →",
  },
  understanding: {
    overline: "The requirement behind the requirement",
    headline: "The real problem: things get built before they are understood.",
    p1: "Behind almost every requirement there is a second, more important one: the goal behind it. “A dashboard” can mean many things - deciding faster, spotting problems earlier or automating reports. Depending on which one applies, the right solution looks very different.",
    p2: "Most vendors simply build what was ordered. We clarify the goal first - and often end up building something better than what the original spec asked for.",
    saidLabel: "You say",
    meaningsLabel: "This can mean",
    clarify: "That is exactly what we clarify before we build.",
    exampleAria: "Example",
    examples: [
      {
        said: "“We need a dashboard.”",
        meanings: [
          "Decide faster?",
          "Spot problems earlier?",
          "Automate reporting?",
        ],
      },
      {
        said: "“We need an app.”",
        meanings: [
          "Strengthen customer loyalty?",
          "Take processes mobile?",
          "Reach a new audience?",
        ],
      },
      {
        said: "“We want to adopt AI.”",
        meanings: [
          "Cut costs?",
          "Deliver faster?",
          "Make company knowledge accessible?",
        ],
      },
    ],
    principles: [
      {
        title: "Understand first, then build.",
        text: "We ask the uncomfortable questions at the start - instead of the expensive ones at the end.",
      },
      {
        title: "Plain language instead of buzzwords.",
        text: "You get an honest assessment of what makes technical sense. Even if the answer is: “You don't need that.”",
      },
      {
        title: "Any challenge.",
        text: "We keep our skill set deliberately broad - because real problems rarely respect technology boundaries.",
      },
    ],
  },
  process: {
    overline: "How we work",
    headline: "Full transparency: this is how a project with us works.",
    intro:
      "Most software projects fail because of misunderstandings, not because of the code. That is why our process is built so you know where your project stands at every stage - and can step in at any time.",
    steps: [
      {
        title: "Intro call",
        badge: "free & non-binding",
        text: "30 minutes in which we listen. You describe your project, we ask the questions others forget. By the end you know whether and how we can help - even if the honest answer is “we can't”.",
      },
      {
        title: "Understanding requirements",
        text: "Our specialty: finding out what you actually need - beyond what the spec says. We question, sketch and sharpen together with you until the goal is clear. Only then do we talk scope and budget.",
      },
      {
        title: "A transparent offer",
        text: "You get an offer you can understand: what gets built, in which stages, at what cost - every item clearly broken down, predictable to the end. And if a simpler solution reaches your goal better, we will propose it - even if it makes the project smaller.",
      },
      {
        title: "Development in short cycles",
        text: "We deliver in short, visible increments. You regularly see working software - not just status reports. Changes? Part of the plan. We work so that course corrections stay possible.",
      },
      {
        title: "Handover & operations",
        text: "After launch we stay at your side: operations, monitoring, further development - hosted by us or in your infrastructure. Your code, your data, your call.",
      },
    ],
    closing: "The first step costs you just 30 minutes.",
    cta: "Book an intro call",
  },
  iot: {
    overline: "IoT & TripRock",
    headlinePlain: "IoT that runs in the field:",
    headlineAccent: "over 2,000 devices in production.",
    intro:
      "Our software proves its production readiness every single day. Under the TripRock brand, together with our partners, we develop our own IoT sensors and IoT systems - hardware and software from a single source, made in Germany. That is a proof of competence stronger than any reference slide.",
    statLabels: [
      "devices in production",
      "years of measurement engineering",
      "months of battery life",
    ],
    blocks: [
      {
        title: "Our own sensors & devices",
        text: "From circuit board to app: we build IoT devices that endure in the field - with up to 24 months of battery life and robust wireless connectivity.",
      },
      {
        title: "DataHub, our IoT backend",
        text: "Our self-developed backend handles complete device management: OTA updates, data forwarding via HTTP and MQTT, alerts, AI-assisted monitoring and dashboards - all in one place.",
      },
      {
        title: "Your hosting, your rules",
        text: "DataHub runs as a managed service with us - or fully on-premise in your infrastructure. Your device data leaves your premises only if you want it to. Your data, your decision.",
      },
      {
        title: "For your IoT project too",
        text: "You have your own devices, machines or an IoT idea? We bring experience from building our own products - from hardware selection and connectivity to data analysis.",
      },
    ],
    showcaseLabel: "Our products under TripRock",
    products: [
      "Environmental & climate sensor",
      "Freight monitoring",
      "Water detector",
      "Position monitoring",
    ],
    showcaseLink: "All products at triprock.de →",
    marqueeHeading: "Modular platform - a selection of our sensor technology",
    sensors: [
      "NB-IoT / GSM",
      "GPS",
      "Temperature",
      "Humidity",
      "Particulate matter",
      "Acceleration",
      "Vibration",
      "Battery",
      "Position",
      "Geofencing",
      "Mesh network",
      "Water",
      "Power flow",
      "Tamper protection",
    ],
    footerLine: "More about the IoT brand and its products:",
  },
  references: {
    overline: "Projects",
    headline: "Trust is built on results.",
    intro:
      "From process automation in mid-sized companies to IoT rollouts with thousands of devices - a look at the kind of projects we deliver.",
    cards: [
      {
        tags: ["Custom software", "System integration"],
        title: "Digitizing processes, connecting systems",
        text: "Tailor-made business applications that map grown workflows and cleanly connect existing systems like ERP and CRM - so data flows instead of sitting in silos.",
      },
      {
        tags: ["AI", "Automation"],
        title: "Bringing AI into existing software and workflows",
        text: "Document processing, assistant features and intelligent automation - integrated into existing systems, production-ready instead of proof-of-concept.",
      },
      {
        tags: ["IoT", "DataHub"],
        title: "IoT rollouts from sensor to dashboard",
        text: "Our own sensor hardware, device management and data analysis through our DataHub backend - over 2,000 devices run on it in production today.",
      },
    ],
    facts: [
      "2,000+ IoT devices in production",
      "Our own products under the TripRock brand",
      "Software engineering from Germany",
    ],
    closing:
      "Want to know whether we have already delivered a project like yours? Ask us directly - in the intro call we will show you relevant examples.",
    ctaLink: "Book an intro call →",
  },
  values: {
    headline: "How you can tell you are in good hands with us.",
    cards: [
      {
        title: "We understand what you actually need",
        text: "Behind every requirement there is a goal. We keep asking until we know it - and sometimes propose the simpler solution if it reaches the goal better. Even if it means less revenue for us.",
      },
      {
        title: "We say no when no is the right answer",
        text: "If we believe a project won't work or won't pay off, we tell you in the intro call - not in month six.",
      },
      {
        title: "You talk to the people who build",
        text: "You have a direct line to the developers implementing your project - decisions happen fast and without friction.",
      },
      {
        title: "Flexible on the path, committed to the goal",
        text: "Requirements change - that is normal. What stays constant with us: availability, commitments and the quality of what we deliver.",
      },
    ],
    footnote:
      "Rocknitive GmbH - software engineering from Germany. Together with our partners we cover software and hardware from a single source.",
  },
  contact: {
    overline: "Contact",
    headlinePlain: "Let's get to know each other:",
    headlineAccent: "30 minutes, free, non-binding.",
    intro:
      "An open conversation instead of a sales pitch: you tell us about your project, we ask the right questions and give you our honest take - plus what a path to implementation could look like.",
    takeawaysLabel: "What you take away from the call",
    takeaways: [
      "An honest first assessment of your project",
      "A clear answer on whether AI adds real value to it",
      "Concrete next steps - even if you take them without us",
    ],
    cardTitle: "Book your slot online",
    cardText: "Pick a free slot in our calendar - booked in under a minute.",
    cardButton: "Book a slot now",
    cardExternal: "Or open Calendly directly ↗",
    cardGdpr: "Loading the calendar transfers data to Calendly.",
    calendlyTitle: "Calendly - book an appointment",
    emailPrefix: "Prefer writing?",
    emailSuffix: "- we will get back to you promptly.",
    microTrust:
      "Free & non-binding · Direct contact with the development team · Response guaranteed",
    microReassurance:
      "From the very first conversation you talk to someone who will later help build your solution.",
  },
  footer: {
    brand:
      "Rocknitive GmbH - software engineering from Germany. Custom software, AI and IoT for mid-sized companies and enterprises.",
    navLabel: "Navigation",
    nav: [
      { name: "Services", id: "leistungen" },
      { name: "AI", id: "ai-first" },
      { name: "IoT & TripRock", id: "iot-triprock" },
      { name: "How we work", id: "prozess" },
      { name: "Projects", id: "referenzen" },
      { name: "Principles", id: "arbeitsweise" },
      { name: "Contact", id: "kontakt" },
    ],
    projectsLabel: "Projects",
    triprockLabel: "TripRock - IoT 360°, everything from one source",
    contactLabel: "Contact",
    bookCall: "Book an intro call →",
    imprint: "Imprint",
    privacy: "Privacy",
  },
  imprint: {
    title: "Imprint",
    tmg: "Information according to § 5 TMG",
    directors: "Authorized representative managing directors:",
    court: "Local court:",
    courtValue: "Lübeck",
    regNumber: "Registration number:",
    responsible: "Responsible for the content according to § 55 Abs. 2 RStV:",
    back: "Back",
  },
  privacy: {
    title: "Privacy Policy",
    note: "The legally binding privacy policy is provided in German below.",
    back: "Back",
  },
};

export const translations = { de, en };
export type Translation = typeof de;
